export default __webpack_public_path__ + "static/media/policy-alert.946526ba.svg";